export default __webpack_public_path__ + "static/media/Icon14_On.700062ba.png";